import React, { useEffect, useRef, useState } from 'react';
import Footer from "../layouts/footer";
import Navbar from "../layouts/nav";
import TypingComponent from './helpers/typingdata';
import { Link } from 'react-router-dom';
import AnimalSnapshot from './animalSnapshot';
import AnimalParentComponent from './spotlight/parent';


export default function Home(){

	const [data, setData] = useState([]);

	useEffect(() => {
		// Fetch data here
		fetch('https://biouniverse-api.vercel.app/animal_snapshot')
		  .then(res => res.json())
		  .then(data => setData(data))
		  .catch(err => console.log(err));
	  }, []);

	useEffect(() => {

		// List of JS files to reload
		const jsFiles = [
		  'assets/js/typed.js',
		  'assets/js/scrolltoTop.js',
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

	//   if(data.length === 0 ){
	// 	return <div>Loading....</div>
	//   }

  return (

    <>
    <Navbar active={'home'} />
	<TypingComponent/>

	<div className="hero">
		<div className="container">
			<div className="row align-items-center">
				<div className="col-lg-10">
					<div className="intro-wrap">
						<h1 className="mb-0"><span className="d-block">Let's Learn</span> About <span className="typed-words typing_color"></span></h1>
					</div>
				</div>
					<div className="slides">
						<img src="https://images.unsplash.com/photo-1565578832914-bc1fbc2ca534?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fGFxdWFyaXVtfGVufDB8MHwwfHx8MA%3D%3D&auto=format&fit=crop&w=1000" alt="Image" className="img-fluid active"/>
						<img src="https://images.pexels.com/photos/1268874/pexels-photo-1268874.jpeg?auto=compress&cs=tinysrgb&w=1000" alt="Image" className="img-fluid"/>
						<img src="https://images.pexels.com/photos/326116/pexels-photo-326116.jpeg?auto=compress&cs=tinysrgb&w=1000" alt="Image" className="img-fluid"/>
						<img src="https://images.pexels.com/photos/730539/pexels-photo-730539.jpeg?auto=compress&cs=tinysrgb&w=1000" alt="Image" className="img-fluid"/>
						<img src="https://images.pexels.com/photos/631292/pexels-photo-631292.jpeg?auto=compress&cs=tinysrgb&w=1000" alt="Image" className="img-fluid"/>
						<img src="https://images.pexels.com/photos/927497/pexels-photo-927497.jpeg?auto=compress&cs=tinysrgb&w=1000" alt="Image" className="img-fluid"/>
					</div>
			</div>
		</div>
	</div>


	{/* category section */}

	<div className="untree_co-section">
		<div className="container-fluid">
			<div className="row text-center justify-content-center mb-5">
				<div className="col-lg-7"><h2 className="section-title text-center">Categories</h2></div>
			</div>

			<div className="owl-carousel owl-3-slider ">

				<div className="item">
					<Link className="media-thumb" to="/category_mammals" >
						<div className="media-text">
							<h3 className='category_names'>Mammals</h3>
						</div>
						<img src="https://images.pexels.com/photos/6551925/pexels-photo-6551925.jpeg?auto=compress&cs=tinysrgb&w=400" alt="mammal" className="img-fluid"/>
					</Link> 
				</div>

				<div className="item">
					<Link className="media-thumb" to="/category_reptiles" >
						<div className="media-text">
							<h3 className='category_names'>Reptiles</h3>
						</div>
						<img src="https://images.pexels.com/photos/62289/yemen-chameleon-chamaeleo-calyptratus-chameleon-reptile-62289.jpeg?auto=compress&cs=tinysrgb&w=400" alt="Image" className="img-fluid"/>
					</Link> 
				</div>

				<div className="item">
					<Link className="media-thumb" to="/category_birds" >
						<div className="media-text">
							<h3 className='category_names'>Birds</h3>
						</div>
						<img src="https://images.pexels.com/photos/788655/pexels-photo-788655.jpeg?auto=compress&cs=tinysrgb&w=400" alt="bird" className="img-fluid"/>
					</Link> 
				</div>


				<div className="item">
					<Link className="media-thumb" to="/category_amphibian" >
						<div className="media-text">
							<h3 className='category_names'>Amphibians</h3>
						</div>
						<img src="https://images.pexels.com/photos/638689/pexels-photo-638689.jpeg?auto=compress&cs=tinysrgb&w=400" alt="ambhibian" className="img-fluid"/>
					</Link> 
				</div>

				<div className="item">
					<Link className="media-thumb" to="/category_marines" >
						<div className="media-text">
							<h3 className='category_names'>Marine</h3>
						</div>
						<img src="https://images.pexels.com/photos/4886378/pexels-photo-4886378.jpeg?auto=compress&cs=tinysrgb&w=400" alt="marine" className="img-fluid"/>
					</Link> 
				</div>

				<div className="item">
					<Link className="media-thumb" to="/category_endangered" >
						<div className="media-text">
							<h3 className='category_names category_names_endangered'>Endangered</h3>
						</div>
						<img src="https://images.pexels.com/photos/145902/pexels-photo-145902.jpeg?auto=compress&cs=tinysrgb&w=400" alt="endangered" className="img-fluid"/>
					</Link> 
				</div>

			</div>

		</div>
	</div>

	{/* animal snapshot section */}

	{/* <AnimalSnapshot data={data}/> */}

	{/* Daily Animal spotlight */}

	<AnimalParentComponent/>

	{/* Gallery section  */}

	<div className="untree_co-section testimonial-section mt-5">
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-lg-10 text-center">
					<h2 className="section-title text-center mb-5">Gallery</h2>

					<p className='pb-5' style={{fontSize: '1rem'}}>
						Step into our mesmerizing Gallery and witness the captivating beauty of the animal kingdom. From majestic lions to graceful dolphins, each image reflects the diversity and wonder of creatures worldwide. Let these snapshots inspire you to cherish and protect our precious co-inhabitants on this planet. Enjoy the enchanting journey through the animal world!
					</p>

<div className="accordion_images">
  <div className="accordion_image"><img src="https://images.pexels.com/photos/3220368/pexels-photo-3220368.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/133459/pexels-photo-133459.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/2786709/pexels-photo-2786709.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/1386560/pexels-photo-1386560.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/704320/pexels-photo-704320.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/1003848/pexels-photo-1003848.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/2922672/pexels-photo-2922672.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/45170/kittens-cat-cat-puppy-rush-45170.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/47547/squirrel-animal-cute-rodents-47547.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
  <div className="accordion_image"><img src="https://images.pexels.com/photos/638738/pexels-photo-638738.jpeg?auto=compress&cs=tinysrgb&w=500" alt=""/></div>
</div>

				<p><Link to="/gallery" className="btn btn-primary mt-5 pt-3 pb-3 pl-5 pr-5" style={{fontSize: '1rem'}}>Explore</Link></p>

				</div>
			</div>
		</div>
	</div>
	
	{/* contact Us section  */}

	<div className="py-5 cta-section">
		<div className="container">
			<div className="row text-center">
				<div className="col-md-12">
					<h2 className="mb-2 text-white">Lets Learn Together. Contact Us Now</h2>
					<p className="mb-4 lead text-white text-white-opacity">
					A gateway to connect with us and share your thoughts, inquiries, and experiences. We value your feedback and look forward to hearing from you.
					</p>
					<p className="mb-0"><Link to="/contact" className="btn btn-outline-white text-white btn-md font-weight-bold">Get in touch</Link></p>
				</div>
			</div>
		</div>
	</div>


	<Footer current={'home'}/>
  </>
  );
}

